<template>
  <div class="home">
    <!-- <app-member></app-member> -->
    <NewMember></NewMember>
    <app-coupon></app-coupon>
    <app-trial></app-trial>
    <app-recommend></app-recommend>

  </div>
</template>

<script>
  import Member from "./member/Member.vue";
  import NewMember from "./NewMember/NewMember.vue";
  import Coupon from "./coupon/Coupon.vue";
  import Trial from "./trial/Trial.vue";
  import Recommend from "./recommend/Recommend.vue";

  export default {
    // 注册组件
    components: {
      appMember: Member,
      appCoupon: Coupon,
      appTrial: Trial,
      appRecommend: Recommend,
      NewMember
    },
    created () {
      // let body = document.querySelector('body');
      // body.style.background = 'none'
      if(Date.parse(new Date()) < Date.parse(new Date('2020/5/1 00:00:01'))) {
        alert("V卡新权益将在5月1日正式生效。")
      }
    }
  }

</script>

<style scoped>

  img{
    width: 100%;
  }
  .home{
    overflow: hidden;
    background: url('../../assets/images/bodybg.png') no-repeat;
    background-size: 100%;
    background-position: top;
  }
</style>


// WEBPACK FOOTER //
// src/component/home/Home.vue